import React, { useEffect } from 'react';
import Divider from '@mui/joy/Divider';
import Switch from '@mui/joy/Switch';
import "./boxes.scss"
import { labelValue, stripHtml } from '../Helpers';
import { Button, FormLabel } from '@mui/joy';
import DynamicEditModal from '../DynamicComponents/DynamicEditModal';
import { toast } from 'react-toastify';
import { ApiService } from '../../api/ProjectInfoService';
import { Project } from '../../Objects/Project';
import { useState } from 'react';

interface Props {
    title: string;
    project: Project;
    userIsPrivileged: boolean;
}

const AlgemeenBox = ({ title, project, userIsPrivileged }: Props) => {
  const [openEditModal, setOpenEditModal] = React.useState<boolean>(false);
  const [values, setValues] = useState<{ label: string; value: string , lang: string}[]>([]);
  useEffect(() => {
    setValues([
      { label: "Teams Naam", value: stripHtml(project?.title), lang: "title" }
    ]);
  }, [])
  const handleOnClose = () => {
    setOpenEditModal(false);
  }

  const handleSave = (data: any) => {
            // map data to correct format
            const mappendata = {
              projectDospId: project.dospId,
              titel: data.find((item: any) => item.lang === "title") ? data.find((item: any) => item.lang === "title")?.value : project.title,  
            }
            console.log("mappendata", mappendata);
        
            ApiService.postProject(mappendata).then((res) => {
              toast.success("Project succesvol aangevraagd om aan te passen");
              setOpenEditModal(false);
            }
            ).catch((error : any) => {
              console.log(error);
              toast.error("Er is iets misgegaan bij het aanvragen om het project aan te passen");
            }
            );

    setOpenEditModal(false);
  }
    return (
      <div className="box">
                {userIsPrivileged && <DynamicEditModal
        isOpen={openEditModal}
        onClose={handleOnClose}
        onSave={handleSave}
        values={values}/>}
        <h3>
          {title}
          {userIsPrivileged && <Button
            className="headerButton"
            variant="outlined"
            color="neutral"
            onClick={() => setOpenEditModal(true)}
          >
            Wijzig
          </Button>}
        </h3>
        <div className="items">
          {labelValue(stripHtml(project?.title), "Teams Naam")}
          {labelValue(project?.language, "Taal")}
          {labelValue(project?.dospId, "DOSP ID")}
          {labelValue(project?.projectStatus?.name, "Status")}
          {labelValue(project?.projectType?.name, "Type")}
          {labelValue(project?.acronym, "Acroniem")}
          {labelValue(project?.totalBudget ? "€ "+ project?.totalBudget: "" , "Totale Budget")}
          <div>
            <FormLabel>BTW-plichtig</FormLabel>
            <Switch
              checked={project.vatLiable}
              disabled
              sx={{
                '--Switch-trackBackground': project.vatLiable ? 'var(--color-box-header-text)' : 'rgba(0,0,0,0.2)',
                '--Switch-trackColor': '#fff',
                '&.Mui-disabled': {
                  opacity: 0.8,
                  '--Switch-trackBackground': project.vatLiable ? 'var(--color-box-header-text)' : 'rgba(0,0,0,0.2)',
                },
              }}
            />
          </div>
          <Divider />
          {labelValue(project?.websiteUrl, "Website")}
        </div>
      </div>
    );
};

export default AlgemeenBox;
